import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  menuToggle: false
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    toggleMenuAction: (state) => {
      state.menuToggle = !state.menuToggle
    },
    // 如果需要，还可以添加其他 actions
    setMenuAction: (state, action) => {
      state.menuToggle = action.payload
    }
  }
})

// 自动生成的 action creators
export const { toggleMenuAction, setMenuAction } = appSlice.actions

// Selectors
export const selectMenuToggle = (state) => state.app.menuToggle

// Reducer
export default appSlice.reducer